import { cx } from '@emotion/css';
import type { FC } from 'react';

import { dataSetToAttributes } from '../../utils';
import { IconButton } from '../IconButton';
import { IconButtonSize } from '../IconButton/IconButton.types';
import { testIds } from './GlobalHeader.constants';
import {
  globalHeaderCtaDesktopCss,
  globalHeaderDesktopContainerCss,
  globalHeaderDesktopCss,
  globalHeaderDesktopNavButtonCss,
  globalHeaderDesktopRelativeParentCss,
  globalHeaderLessMarginsCss,
  globalHeaderSiteNameCss,
  globalHeaderUnderlineCss,
} from './GlobalHeader.styles';
import type { GlobalHeaderDesktopProps } from './types';

const alignmentToCss = (alignment: 'left' | 'right' | 'center') => {
  switch (alignment) {
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    case 'center':
      return 'center';
  }
};

export const GlobalHeaderDesktop: FC<GlobalHeaderDesktopProps> = ({
  logo,
  siteName,
  className,
  cta,
  endChildrenClassName,
  localNavDesktop,
  toggleExpanded,
  showNavScreen,
  showGlobalLinks = true,
  navItemAlignment = 'right',
  buttonAriaLabel,
  dataset,
  lessMargins,
  addBottomBorder,
  customIcon,
  headerClassName,
}) => (
  <header
    className={cx(globalHeaderDesktopCss, globalHeaderSiteNameCss, className, headerClassName)}
    {...dataSetToAttributes(dataset)}
  >
    {/* we need this wrapper div for the bottom border... */}
    <div className={globalHeaderDesktopRelativeParentCss}>
      {/* // HACK: we move everything inside a div with overflow visible, and do the clip on the header parent */}
      <div
        className={cx(globalHeaderDesktopContainerCss, lessMargins && globalHeaderLessMarginsCss)}
      >
        {showGlobalLinks && showNavScreen && (
          <IconButton
            size={IconButtonSize.LARGE}
            className={globalHeaderDesktopNavButtonCss}
            iconName={customIcon || 'dots'}
            onClick={toggleExpanded}
            data-testid={testIds.openButton}
            aria-label={buttonAriaLabel}
          />
        )}
        {logo}
        <span className="site-name">{siteName}</span>
        <nav
          style={{ justifyContent: alignmentToCss(navItemAlignment) }}
          data-testid={testIds.navItems}
        >
          {localNavDesktop}
        </nav>
        <aside
          className={endChildrenClassName ?? globalHeaderCtaDesktopCss}
          data-testid={testIds.endContents}
        >
          {cta}
        </aside>
      </div>
      {addBottomBorder && <div className={globalHeaderUnderlineCss} />}
    </div>
  </header>
);

GlobalHeaderDesktop.displayName = 'GlobalHeaderDesktop';
